import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoCustomerServiceAction, 
  setIsFetching, 
  setFetchFailed, 
  setCustomerServiceContent,
} from 'Components/InfoCustomerService/Redux/actions';

export const fetchCustomerServiceContent = () => {
  return async (dispatch: Dispatch<InfoCustomerServiceAction>): Promise<void> => {
    const { isFetching, content } = Store.getState().infoCustomerService;

    if (isFetching || content) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('CustomerServicePage');

      if (response.status !== 200) {
        dispatch(setFetchFailed());
      } else {
        const newContent: Julius.Website.TermsPageViewModel = await response.json();
        dispatch(setCustomerServiceContent(newContent));
      }
      
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/InfoCustomerService/Redux/thunks.tsx